import { printAST, transformAST, generateJsxKey, parseStyleAttribute, xml2ast, allHtmlParsers } from '@utils/ast';
import { iGuideHtmlNodeLatexPrinters } from './spec.html.js';
import ContextImage from './spec.image.comp.js';
import { jsx } from 'react/jsx-runtime';

/* eslint-disable no-irregular-whitespace */

const imageParsers = {
  img: node => {
    const src = node.getAttribute("src");
    const alt = node.getAttribute("alt") || undefined;
    const width = parseInt(node.getAttribute("width") ?? "");
    const height = parseInt(node.getAttribute("height") ?? "");
    const longDesc = node.getAttribute("data-long-desc");
    const style = parseStyleAttribute(node.getAttribute("style"));
    const cssWidth = style?.["width"];
    const latex = node.getAttribute("data-latex");
    return {
      nodeType: "img",
      src,
      alt,
      longDesc: longDesc ? xml2ast(longDesc, allHtmlParsers, "text/html") : undefined,
      latex,
      cssWidth,
      dimensions: {
        width: Number.isNaN(width) ? undefined : width,
        height: Number.isNaN(height) ? undefined : height
      }
    };
  }
};
const imagePrinters = {
  img: (node, context) => {
    return /*#__PURE__*/jsx(ContextImage, {
      node: node
    }, generateJsxKey(context));
  }
};
const imageToLatexPrinters = {
  img: node => {
    if (node.latex) {
      return ` \\\\\n$${node.latex}$ \\\\\n`;
    }
    if (!node.caption) {
      return `\\includegraphics[width=\\textwidth]{${node.src}}`;
    }
    const caption = printAST(transformAST(node.caption, node => {
      if (node.attributes?.["class"]?.includes("richtext--image-caption--title")) {
        return {
          ...node,
          tagName: "b"
        };
      }
      return node;
    }), {
      ...iGuideHtmlNodeLatexPrinters
    });
    return `\\begin{figure}
\\includegraphics[width=\\textwidth]{${node.src}}
\\caption{${caption}}
\\end{figure}
`;
  }
};

export { imageParsers, imagePrinters, imageToLatexPrinters };
//# sourceMappingURL=spec.image.js.map
